import apiWrapper from 'Helpers/apiWrapper'
import { encodeParams } from 'mailup-react-helpers'

const endpoints = ((baseURL) => {
  return {
    getListOfContents: (idSource, params) =>
      `${baseURL}/api/sources/${idSource}/contents?${encodeParams(params)}`,
    countContents: (idSource) =>
      `${baseURL}/api/sources/${idSource}/contents/count`
  }
})(process.env.CONTENTS_PROVIDER_URL)

export const beContentProviderGetListOfContents = (idSource, params) => {
  return apiWrapper({
    method: 'get',
    url: endpoints.getListOfContents(idSource, params)
  }).then(({ data }) => {
    return data
  })
}

export const beContentProviderApiCountContents = (idSource) => {
  return apiWrapper({
    method: 'get',
    url: endpoints.getListOfContents(idSource)
  }).then(({ data }) => {
    return data
  })
}
